import * as roleConst from 'auth/roleConst';

export function isHasManageView(auth) {
    const roleObj = auth?.role;
    const workspaceAuthorities = auth?.workspaceAuthorities;
    if (roleObj?.[roleConst.COMPANY_AUTHORITIES.MANAGE_WORKSPACE]) return true;

    return workspaceAuthorities?.includes(roleConst?.WORKSPACE_AUTHORITIES.MANAGE_VIEW);
}
